import React from 'react';
import { Error404 } from './Error404';

export const ErrorView = ({ statusCode }: { statusCode: number }) => {
  document.getElementById('loaderDiv')?.remove();

  if (statusCode === 404) {
    return <Error404 />;
  }
  if (statusCode === 403) {
    return <Error404 />;
  }

  return null;
};
